import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Pencil, Plus, FileText } from "lucide-react";
import { api } from "@/lib/api";
import { fmtStamp } from "@/lib/format";
import { PageHeader, LoadingBlock } from "@/components/Shared";
import { ClientDialog } from "@/pages/admin/Clients";

export default function ClientDetail() {
  const { id } = useParams();
  const [c, setC] = useState(null);
  const [open, setOpen] = useState(false);
  const load = () => api.get(`/clients/${id}`).then((r) => setC(r.data));
  useEffect(() => { load(); }, [id]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!c) return <LoadingBlock />;
  return (
    <div className="fade-up">
      <Link to="/admin/clients" className="mb-3 inline-flex items-center gap-1 text-sm font-semibold text-slate-600 hover:text-[#5C241E]" data-testid="client-back-link"><ArrowLeft className="h-4 w-4" />Clients</Link>
      <PageHeader eyebrow={c.status === "active" ? "Active client" : "Inactive client"} title={c.name} actions={<>
        <button className="btn-ghost h-11" onClick={() => setOpen(true)} data-testid="client-detail-edit"><Pencil className="h-4 w-4" />Edit</button>
        <Link to={`/admin/reports?client_id=${c.id}`} className="btn-ghost h-11" data-testid="client-view-reports"><FileText className="h-4 w-4" />View reports</Link>
        <Link to={`/admin/projects/new?client_id=${c.id}`} className="btn-brand h-11" data-testid="client-add-project"><Plus className="h-4 w-4" />Add project</Link>
      </>} />
      <div className="grid gap-4 lg:grid-cols-3">
        <div className="panel space-y-3 p-4 text-sm">
          {[["Contact", c.contact_name], ["Email", c.contact_email], ["Phone", c.contact_phone], ["Created", fmtStamp(c.created_at)], ["Updated", fmtStamp(c.updated_at)]].map(([k, v]) => (
            <div key={k}><p className="text-xs font-bold uppercase tracking-wider text-slate-500">{k}</p><p className="font-semibold">{v || "—"}</p></div>
          ))}
          {c.notes && <div><p className="text-xs font-bold uppercase tracking-wider text-slate-500">Notes</p><p className="whitespace-pre-wrap">{c.notes}</p></div>}
        </div>
        <div className="panel lg:col-span-2">
          <p className="border-b border-border px-4 py-3 font-display text-xl font-semibold">Projects ({c.projects.length})</p>
          <div className="divide-y divide-border" data-testid="client-projects-list">
            {c.projects.map((p) => (
              <Link key={p.id} to={`/admin/projects/${p.id}`} className="flex items-center justify-between px-4 py-3 hover:bg-slate-50" data-testid={`client-project-${p.id}`}>
                <span><span className="font-semibold">{p.name}</span><span className="block text-xs text-slate-500">Job # {p.job_number || "—"} · {p.location || "No location"}</span></span>
                <span className="text-xs font-bold uppercase text-slate-500">{p.status.replace("_", " ")}</span>
              </Link>
            ))}
            {!c.projects.length && <p className="px-4 py-6 text-sm text-slate-500">No projects yet.</p>}
          </div>
        </div>
      </div>
      <ClientDialog open={open} onClose={() => setOpen(false)} client={c} onSaved={load} />
    </div>
  );
}
